export default import.meta.ROLLUP_FILE_URL_UHSRZeUan5lM_bBGQxmT4g